export default __webpack_public_path__ + "static/media/menu.04c14ba3.svg";